<template>
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-10">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center items-center p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full max-w-lg sm:p-6"
            >
              <div>
                <!-- <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                  <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true" />
                </div> -->
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">
                    <slot name="title" />
                    <div class="border-2 border-t border-indigo-600 mx-48 my-2"></div>
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      <slot name="description" />
                    </p>
                  </div>
                </div>
              </div>
              <div class="modalDialog mt-5 sm:mt-6 grid grid-flow-row-dense grid-cols-2 gap-3">
                <button
                  type="button"
                  class="pds-no-outline inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-200 col-start-2"
                  @click="handleAction(true)"
                >
                  Ja
                </button>
                <button
                  type="button"
                  class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold pds-text-black shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 col-start-1 mt-0"
                  @click="handleAction(false)"
                >
                  Nee
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref, defineEmits, watch } from 'vue';
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { CheckIcon } from '@heroicons/vue/24/outline';
const props = defineProps({
  modalOpenStatus: {
    type: Boolean,
    required: true,
    default: false
  }
});
// Define the emit function
const emit = defineEmits(['update:isActive']);
const open = ref(false);

// Watcher to track changes in modalOpenStatus and update the open value
watch(
  () => props.modalOpenStatus,
  (newVal) => {
    open.value = newVal;
  },
  { immediate: true } // Add this if you want the watcher to be triggered immediately with the current value
);

// Function to handle button clicks
const handleAction = (value) => {
  emit('update:isActive', value); // Emit true or false to the parent component
};
</script>
